import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0a0e17",
          color: "#fff",
          fontFamily: "'Inter', -apple-system, sans-serif",
          padding: "24px",
        }}>
          <div style={{
            maxWidth: 520,
            width: "100%",
            textAlign: "center",
          }}>
            {/* Icon */}
            <div style={{
              width: 64, height: 64, borderRadius: "50%", margin: "0 auto 20px",
              background: "rgba(255,23,68,0.12)",
              border: "1px solid rgba(255,23,68,0.3)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 28,
            }}>
              ⚠
            </div>

            <h1 style={{
              fontSize: 20, fontWeight: 700, marginBottom: 8,
              letterSpacing: "0.02em",
            }}>
              Bir şeyler ters gitti
            </h1>

            <p style={{
              fontSize: 13, color: "rgba(255,255,255,0.5)",
              marginBottom: 24, lineHeight: 1.6,
            }}>
              Uygulama beklenmeyen bir hatayla karşılaştı. Sayfayı yenilemeyi deneyin.
              Sorun devam ederse lütfen destek ekibiyle iletişime geçin.
            </p>

            {/* Error details (collapsed) */}
            {this.state.error && (
              <details style={{
                textAlign: "left",
                background: "rgba(255,255,255,0.03)",
                border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: 8,
                padding: "12px 16px",
                marginBottom: 24,
                fontSize: 11,
                fontFamily: "'JetBrains Mono', monospace",
                color: "rgba(255,255,255,0.4)",
                maxHeight: 200,
                overflow: "auto",
              }}>
                <summary style={{ cursor: "pointer", marginBottom: 8, color: "rgba(255,255,255,0.6)" }}>
                  Hata Detayı
                </summary>
                <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                  {this.state.error?.toString()}
                </div>
                {this.state.errorInfo?.componentStack && (
                  <div style={{ marginTop: 8, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                    {this.state.errorInfo.componentStack}
                  </div>
                )}
              </details>
            )}

            {/* Actions */}
            <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
              <button
                onClick={this.handleReset}
                style={{
                  padding: "10px 24px",
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.12)",
                  borderRadius: 6,
                  color: "#fff",
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: "pointer",
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                }}
              >
                Tekrar Dene
              </button>
              <button
                onClick={this.handleReload}
                style={{
                  padding: "10px 24px",
                  background: "linear-gradient(135deg, #00e676, #00c853)",
                  border: "none",
                  borderRadius: 6,
                  color: "#000",
                  fontSize: 12,
                  fontWeight: 700,
                  cursor: "pointer",
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                }}
              >
                Sayfayı Yenile
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
